import React from "react";
import {
  Pressable as RNPressable,
  PressableProps,
  StyleProp,
  ViewStyle,
} from "react-native";

interface CustomPressableProps extends PressableProps {
  style?:
    | StyleProp<ViewStyle>
    | ((state: { pressed: boolean }) => StyleProp<ViewStyle>);
}

const Pressable: React.FC<CustomPressableProps> = ({
  style,
  children,
  ...props
}) => {
  return (
    <RNPressable
      style={({ pressed }) => [
        {
          opacity: pressed ? 0.5 : 1.0,
        },
        style && typeof style === "function" ? style({ pressed }) : style, // Allows custom styles as function or object
      ]}
      {...props}
    >
      {children}
    </RNPressable>
  );
};

export default Pressable;
